import { useMemo } from 'react';
import { FiservCardInterface, FiservCardStatusEnum, useIsCardMailWithin7Days } from '@common-fe/common-fe';


const LAST_FOUR_ZERO = '0000';

export const useShouldShowCardActions = (card: FiservCardInterface) => {
  const {
    status,
    last4Number,
    primary
  } = card;
  const isMailWithin7Days = useIsCardMailWithin7Days(card);
  const last4NumberIsNotZero = useMemo(() => last4Number !== LAST_FOUR_ZERO, [last4Number]);
  const readyForActivation = useMemo(
    () => card?.status === FiservCardStatusEnum.PENDING_OPEN && !card?.activationDate && card?.mailedDate,
    [card?.activationDate, card?.mailedDate, card?.status]);
  
  const disableManage = useMemo(() => card?.status === FiservCardStatusEnum.PENDING_OPEN && isMailWithin7Days, [card?.status, isMailWithin7Days]);
  const showReplaceActionCard = useMemo(
    () => (status === FiservCardStatusEnum.PENDING_OPEN && !isMailWithin7Days)
    || status === FiservCardStatusEnum.ACTIVE 
    || status === FiservCardStatusEnum.PENDING_UNLOCK, [status, isMailWithin7Days]);

  const showCloseActionCard = useMemo(
    () => !primary
      && (status === FiservCardStatusEnum.ACTIVE 
      || status === FiservCardStatusEnum.PENDING_UNLOCK 
      || status === FiservCardStatusEnum.FROZEN
      || status === FiservCardStatusEnum.PENDING_FROZEN), [status, primary]);

  const showLockUnlockActionCard = useMemo(
    () => (status === FiservCardStatusEnum.PENDING_OPEN && last4NumberIsNotZero)
    || status === FiservCardStatusEnum.ACTIVE 
    || status === FiservCardStatusEnum.PENDING_UNLOCK 
    || status === FiservCardStatusEnum.FROZEN
    || status === FiservCardStatusEnum.PENDING_FROZEN, [status, last4NumberIsNotZero]);

  return {
    readyForActivation,
    disableManage,
    last4NumberIsNotZero,
    showReplaceActionCard,
    showCloseActionCard,
    showLockUnlockActionCard,
  };
};
